export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "header": {
          "platformDescription": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skillspace is an open platform for creating and promoting online courses."])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Learn More"])},
          "partnerProgram": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Partner Program"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
          "register": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Register"])}
        }
      },
      "ru": {
        "header": {
          "platformDescription": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skillspace - это открытая платформа для создания и продвижения онлайн-курсов."])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Узнать больше"])},
          "partnerProgram": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Партнерская программа"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вход"])},
          "register": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Регистрация"])}
        }
      },
      "es": {
        "header": {
          "platformDescription": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skillspace es una plataforma abierta para la creación y promoción de cursos en línea."])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Más información"])},
          "partnerProgram": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Programa de socios"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iniciar sesión"])},
          "register": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registrarse"])}
        }
      },
      "kk": {
        "header": {
          "platformDescription": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skillspace - бұл онлайн курстарды құру және ілгерілету үшін ашық платформа."])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Көбірек білу"])},
          "partnerProgram": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Әріптестік бағдарлама"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кіру"])},
          "register": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тіркелу"])}
        }
      },
      "uz": {
        "header": {
          "platformDescription": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skillspace - bu onlayn kurslarni yaratish va rivojlantirish uchun ochiq platforma."])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Batafsil ma'lumot"])},
          "partnerProgram": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hamkor dasturi"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirish"])},
          "register": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ro'yxatdan o'tish"])}
        }
      },
      "de": {
        "header": {
          "platformDescription": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skillspace ist eine offene Plattform zur Erstellung und Vermarktung von Online-Kursen."])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mehr erfahren"])},
          "partnerProgram": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Partnerprogramm"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmelden"])},
          "register": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registrieren"])}
        }
      },
      "fr": {
        "header": {
          "platformDescription": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skillspace est une plateforme ouverte pour la création et la promotion de cours en ligne."])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En savoir plus"])},
          "partnerProgram": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Programme Partenaire"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion"])},
          "register": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inscription"])}
        }
      },
      "it": {
        "header": {
          "platformDescription": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skillspace è una piattaforma aperta per la creazione e la promozione di corsi online."])},
          "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maggiori informazioni"])},
          "partnerProgram": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Programma Partner"])},
          "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accesso"])},
          "register": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registrazione"])}
        }
      }
    }
  })
}
